import AbstractController from '../src/services/ControllersRepository/AbstractController';
import ManagerDashboard from '../views/dashboard/ManagerDashboard';
import AdminDashboard from '../views/dashboard/AdminDashboard';
import ProductionDashboard from '../views/dashboard/ProductionDashboard';
import DashboardResolver from '../views/dashboard/DashboardResolver';
import OrderPage from '@views/dashboard/manager/OrderPage';
import ManagerOrderProductPage from '@views/dashboard/manager/OrderProductPage';
import ProductionOrderProductPage from '@views/dashboard/production/OrderProductPage';
import ProductionOrderOperationsList from '@views/dashboard/production/OrderOperationsList/OrderOperationsList';
import OrderProductsListFilteredByProductId from '@views/dashboard/production/OrderProductsListFilteredByProductId';

export default class Dashboard extends AbstractController {
    protected controllerName = 'Dashboard';

    protected availableActions = [
        'index',
        'admin',
        'manager',
        'managerOrderPage',
        'managerOrderProductPage',
        'production',
        'productionOrderProductPage',
        'productionOperationsList',
        'productionByProductId',
    ];
    protected actionsComponents = {
        index: DashboardResolver,
        admin: AdminDashboard,
        manager: ManagerDashboard,
        managerOrderPage: OrderPage,
        managerOrderProductPage: ManagerOrderProductPage,
        production: ProductionDashboard,
        productionOrderProductPage: ProductionOrderProductPage,
        productionOperationsList: ProductionOrderOperationsList,
        productionByProductId: OrderProductsListFilteredByProductId,
    };
}
